import gsap from "gsap";
import { useGSAP } from "@gsap/react";
// @ts-ignore
import FakeProgress from "fake-progress";
import { useNavigation } from "@remix-run/react";

import * as styles from "./Progress.css";
import { useRef } from "react";

interface Props extends React.ComponentPropsWithoutRef<"div"> {}

export default function Progress({}: Props) {
  const navigation = useNavigation();
  const pending = navigation.state !== "idle";

  // Motion
  const ref = useRef(null);

  useGSAP(
    () => {
      const progress = new FakeProgress({
        timeConstant: 1000,
        autoStart: true,
      });

      const handleTick = () => {
        if (progress.progress === 1) {
          gsap.ticker.remove(handleTick);
        }

        gsap.to(ref.current, {
          autoAlpha: 1,
          scaleX: progress.progress,
          onComplete: () => {
            if (progress.progress === 1) {
              gsap.to(ref.current, {
                scaleX: 0,
                duration: 0,
              });
            }
          },
        });
      };

      gsap.ticker.add(handleTick);

      if (!pending) {
        progress.end();
      }

      return () => {
        gsap.ticker.remove(handleTick);
      };
    },
    { dependencies: [pending], revertOnUpdate: true }
  );

  return <div ref={ref} className={styles.root} />;
}
